export const DESTINATION_TEXTS = {
  fieldLabelFixed: 'Куда',
  placeholder: 'Страна, курорт или отель',
  selectAll: 'Все курорты',
  nothingFound: 'Ничего не найдено',
  groupPopularCountries: 'Популярные направления',
  groupOtherCountries: 'Остальные направления',
  groupPopularResorts: 'Популярные курорты',
  groupOtherResorts: 'Остальные курорты',
  errorEmpty: 'Начните с выбора направления',
  errorInvalid: 'Неверное направление',
} as const;
